import { CREATE_EXEAT, CREATING_EXEAT, EXEATS_ERROR, GET_EXEATS, GETTING_EXEATS, UPDATE_EXEAT, UPDATING_EXEAT } from "../types"

const initialState = {
    exeats: [],
    loadingExeats: true,
    exeatsError: null,
    creatingExeat: false,
    createdExeat: null,
    updatingExeat: false,
    updatedExeat: null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case CREATING_EXEAT:
        return {
            ...state,
            creatingExeat :action.payload,
        }
        case CREATE_EXEAT:
        return{
            ...state,
            creatingExeat:false,
            exeatsError:  null,
            createdExeat: action.payload,
        }
        case UPDATING_EXEAT:
        return {
            ...state,
            updatingExeat :action.payload,
        }
        case UPDATE_EXEAT:
        return{
            ...state,
            updatingExeat:false,
            exeatsError:  null,
            updatedExeat: action.payload,
        }
        case GETTING_EXEATS:
        return {
            ...state,
            loadingExeats :action.payload,
        }
        case GET_EXEATS:
        return{
            ...state,
            loadingExeats:false,
            exeatsError:  null,
            exeats: action.payload,
        }
        case EXEATS_ERROR:
        return{
            ...state,
            loadingExeats:false,
            updatingExeat:false,
            creatingExeat:false,
            exeatsError: action.payload 
        }
        default: return state
    }

}